type ReceiptStore=Pick<Storage,'getItem'|'setItem'>;
const consumed=new Set<string>();

/** A durable handoff may replay through both transports. Open its UI once,
 * including across reloads, without starting analysis or creating a brand. */
export function takeBrandSetupHandoff(projectId:number|null,data:any,receipts?:ReceiptStore):string|undefined{
 if(!Number.isSafeInteger(projectId)||!projectId||typeof data?.url!=='string')return;
 let url:URL;try{url=new URL(data.url);}catch{return;}
 if(!['http:','https:'].includes(url.protocol)||url.username||url.password)return;
 const identity=Number.isSafeInteger(data.workflowRunId)&&data.workflowRunId>0?`run-${data.workflowRunId}`:typeof data.assistantMessageId==='string'?data.assistantMessageId:undefined;
 if(!identity)return;
 const key=`admoji:brand-setup:${projectId}:${identity}`;
 if(consumed.has(key))return;
 try{if(receipts?.getItem(key))return;receipts?.setItem(key,'opened');}catch{/* Session storage may be disabled; retain in-memory deduplication. */}
 consumed.add(key);return url.href;
}
